import React, { Component } from 'react'
import { Col, Row,  FormGroup } from "react-bootstrap"
import moment from 'moment'
import {  Field,reduxForm,propTypes,formValueSelector,
          change,getFormSyncErrors } from 'redux-form'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import {  fetchActiveSeasons, saveSeasonDates,savingData, triggerSeason,resetDatesSettings } from "../../../redux/actions/seasonActions"
import logo from '../../../images/PinStar-15PX.png'
import { renderDatePickerField } from '../../../modules/components/datepickercomponent'
import { style, green, blue } from '../../../utils/constants'
import ErrorList from './ErrorList'
import InfoSaved from './InfoSaved'

const datesTab = 1
const formName = 'seasondates'
class SeasonDates extends Component {
	static propTypes = {
		...propTypes
	}

	constructor(props,context) {
		super(props,context)
		this.seasonOptions      = this.seasonOptions.bind(this)
		this.handleSaveDates    = this.handleSaveDates.bind(this)
		this.handleValueChange = this.handleValueChange.bind(this)
		this.handleSelectedSeasonChange = this.handleSelectedSeasonChange.bind(this)
		this.disableSave = this.disableSave.bind(this)
	}

	componentDidUpdate(){
			
		const {  initialize,datasaved,resetform,resetDatesSettings,settingsSaved,datesreset,resetDone,dispatch } = this.props

		if (datasaved) {
			
			initialize({}, true)
			settingsSaved(true,datesTab)
		}
		if(resetform == true){
				resetDatesSettings()
		}
		if(datesreset == true){
			dispatch(change(formName,'datesreset',false))
			resetDone()
		}
	}

	seasonOptions()
	{
		const { seasondates } = this.props
		const seasondatesarray = Object.values(seasondates)
		const option = seasondatesarray.map((season) => {
			return (<option key={season.id} value={season.id} >{season.description}</option>)
		})
		return option
	}

	handleValueChange(){
		const { dispatch, settingsSaved } = this.props
		dispatch(change(formName,'datasaved',false))
		settingsSaved(false,datesTab) 
	}

	handleSaveDates() {
		const { seasondates,   saveSeasonDates, settingsseason,dispatch } = this.props
		
		const seasonId =  settingsseason
		const season = seasondates[settingsseason]
		const dates = {
			startDate:season.startDate,
			endDate: season.endDate,
			membershipStartDate: season.membershipStartDate,
			membershipEndDate: season.membershipEndDate,
			membershipVerificationStartDate: season.membershipVerificationStartDate,
			juniorTeamUSAEligibilityDate:season.juniorTeamUSAEligibilityDate,
			seasonId
		}
		dispatch(savingData());
		dispatch(saveSeasonDates(seasonId,dates));
	}

	handleSelectedSeasonChange = evt => {
		const { onSeasonChange,seasondates } = this.props;
		const seasonId    = evt.target.value;
		const { description, isSeasonSet } = seasondates[seasonId];

		onSeasonChange(parseInt(seasonId),description,isSeasonSet);
	}

	isSeasonSet(){
		const {  seasondates, settingsseason } = this.props
		let isSeasonSet = true

		if(seasondates){
			isSeasonSet = seasondates[settingsseason].isSeasonSet
		}
		return isSeasonSet
	}

	disableSave() {
		
		const { datasaved,datesreset ,seasondates ,settingsseason,syncErrors } = this.props
		let isSeasonSet = true
		const errors    =  Object.values(syncErrors)
		if(seasondates){
			isSeasonSet = seasondates[settingsseason].isSeasonSet
		}
		return   ((datasaved === undefined) || (datasaved === true) || errors.length > 0 || !isSeasonSet || datesreset)
	}
	render() {

		const {  
			seasondates, 
			settingsseason,
			savingdates,
			datasaved,
			seasontriggered,
			syncErrors,
			onAddSeason
		} = this.props

		const season      = `seasondates[${settingsseason}]`
		const isSeasonSet = this.isSeasonSet()
		const errors =  Object.values(syncErrors)

		return (
			<Row className="center-block center-text">	
				<form name='seasondates' className="form-horizontal" sm={12}  style={{ padding:'0',margin:'0' }} >
					<Col sm={12}>
						{
							(errors.length > 0) && (errors[0] !== 'SeasonNotSet') && <ErrorList errors={errors}/>
						}
					<FormGroup>
						<label className={style.lblattrs4}> 
							<img src={logo} style={{ maxWidth:'30px', marginTop:'-3px' }} />&nbsp;&nbsp;Season Year
						</label>
						<Col sm={8}>
							<Field 
								name='settingsseason' 
								component="select" 
								className={style.inputattrs3}
								onChange={this.handleSelectedSeasonChange}
								style={{ minHeight:'35px',paddingLeft:'10px',marginLeft:'-16px', borderColor:'#C3C3C3', borderRadius:'3px' }} 
							>
								{ seasondates != undefined && this.seasonOptions() } 
							</Field>
						</Col>
					</FormGroup>  
						<Field
							label='Season Start Date'
							labelattrs={style.lblattrs4}
							inputattrs={style.inputattrs3}
							title='Season Start Date'
							name={`${season}.startDate`}
							component={renderDatePickerField}
							placeholder='mm-dd-yyyy'
							onChange={this.handleValueChange}
							disabled = { !isSeasonSet }
							key = '1'
						/>                                                         
						<Field
							label='Season End Date'
							labelattrs={style.lblattrs4}
							inputattrs={style.inputattrs3}
							title='Season End Date'
							name={`${season}.endDate`}
							component={renderDatePickerField}
							placeholder='mm-dd-yyyy'
							onChange={this.handleValueChange}
							disabled = { !isSeasonSet }
							key = '2'
						/> 
						<Field
							label='Membership Year Start Date'
							labelattrs={style.lblattrs4}
							inputattrs={style.inputattrs3}
							title='Membership Year Start Date'
							name={`${season}.membershipStartDate`}
							component={renderDatePickerField}
							placeholder='mm-dd-yyyy'
							onChange={this.handleValueChange}
							disabled = { !isSeasonSet }
							key = '3'
						/>
						<Field
							label='Membership Year End Date'
							labelattrs={style.lblattrs4}
							inputattrs={style.inputattrs3}
							title='Membership Year End Date'
							name={`${season}.membershipEndDate`}
							component={renderDatePickerField}
							placeholder='mm-dd-yyyy'
							onChange={this.handleValueChange}
							disabled = { !isSeasonSet }
							key = '4'
						/>
						<Field
							label='Junior Team USA Eligibility Date'
							labelattrs={style.lblattrs4}
							inputattrs={style.inputattrs3}
							title='Junior Team USA Eligibility Date'
							name={`${season}.juniorTeamUSAEligibilityDate`}
							component={renderDatePickerField}
							placeholder='mm-dd-yyyy'
							onChange={this.handleValueChange}
							disabled = { !isSeasonSet }
							key = '5'
						/>
						<Field
							label='Start Membership Verification on'
							labelattrs={style.lblattrs4}
							inputattrs={style.inputattrs3}
							title='Membership Verification Start Date'
							name={`${season}.membershipVerificationStartDate`}
							component={renderDatePickerField}
							placeholder='mm-dd-yyyy'
							onChange={this.handleValueChange}
							disabled = { !isSeasonSet }
							key = '6'
						/>
						<FormGroup>
							<Col lgOffset={2} lg={6}>									
								<button type="button"   className="btn btn-default"  style={{ color: blue, fontWeight: 800 }} onClick={this.handleSaveDates} disabled={this.disableSave()}>
									<i className={savingdates === true ? 'fa fa-spinner fa-spin':"fa fa-cogs"} aria-hidden="true" /> &nbsp;&nbsp;Save Settings
								</button>
								<button type='button' className="btn btn-default" style={{ color: green, fontWeight: 800, marginLeft:'15px' }} onClick={onAddSeason}>
									<i className="fa fa-calendar" aria-hidden="true" /> &nbsp;&nbsp;Add Season
								</button>
								{
									datasaved && (<InfoSaved section='Season dates' />)
								}
								{
									seasontriggered && (<InfoSaved custommessage='Season has been successfully triggered.' />)
								}
							</Col>
						</FormGroup>
					</Col>
				</form>     
			</Row>              
			)
	}
}

SeasonDates.propTypes = {
    handleSubmit: PropTypes.func,
    syncErrors:PropTypes.object,
    dispatch:PropTypes.func,
    initialize:PropTypes.func,
    reset:PropTypes.func,
    datasaved:PropTypes.bool,
    seasontriggered:PropTypes.bool,
    fetchActiveSeasons: PropTypes.func,
	saveSeasonDates: PropTypes.func,
	savingData: PropTypes.func,  
    triggerSeason:PropTypes.func,
    savingdates:PropTypes.bool,
    isSettingSeason:PropTypes.bool,
    seasonyear: PropTypes.string,
    seasondates:PropTypes.object,
    settingsseason:PropTypes.string,
    onSeasonChange:PropTypes.func,
    settingsSaved: PropTypes.func,
    resetform:PropTypes.bool,
    resetDatesSettings:PropTypes.func,
    resetDone:PropTypes.func,
    datesreset:PropTypes.bool,
	hasSeasonBeenSet:PropTypes.func,
	onAddSeason:PropTypes.func
}

function mapStateToProps(state,ownProps) {
    const formName =  ownProps.form
    const selector = formValueSelector(formName)
    const settingsseason = selector(state,'settingsseason')
    const seasonyear     = selector(state,'seasonyear')
    const seasondates    = selector(state,'seasondates')
    const savingdates     = selector(state,'savingdates')
    const isSettingSeason    = selector(state,'isSettingSeason')
    const datasaved    = selector(state,'datasaved')
    const seasontriggered = selector(state,'seasontriggered')
    const syncErrors = getFormSyncErrors(formName)(state)
    const datesreset    = selector(state,'datesreset')
    return {
        seasondates,
        seasonyear,
        savingdates,
        settingsseason,
        isSettingSeason,
        datasaved,
        seasontriggered,
        syncErrors,
        datesreset
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
        fetchActiveSeasons,
		saveSeasonDates,
		savingData,
        triggerSeason,
        resetDatesSettings
      },dispatch)
}

function validate(values) {

    const { settingsseason,seasondates } = values

    const errors = {}
    
    if(seasondates && settingsseason) {       
        const season = seasondates[settingsseason]
        const { startDate, endDate , membershipStartDate, membershipEndDate,membershipVerificationStartDate, juniorTeamUSAEligibilityDate, isSeasonSet } = season
        let errorCounter = 0
	
        if(isSeasonSet === true) 
        {       
            if (!startDate) {
                errors[errorCounter++] = 'Season Start Date is required'
            }
            if (!endDate) {
                errors[errorCounter++] = 'Season End Date is required'
            }
            if (!membershipStartDate) {
                errors[errorCounter++] = 'Membership Year Start Date is required'
            }
            if (!membershipEndDate) {
                errors[errorCounter++] = 'Membership Year End Date is required'
            }
            if (!juniorTeamUSAEligibilityDate) {
                errors[errorCounter++] = 'Junior Team USA Eligibilty Date is required'
			}
			if (!membershipVerificationStartDate) {
                errors[errorCounter++] = 'Start Membership Verification Date is required'
            }
        
            // Other validations
            if (moment(startDate) > moment(endDate)) {
                errors[errorCounter++]  = 'Season start date cannot be later than the end date'
			}
			if (moment(membershipVerificationStartDate) < moment(membershipStartDate)) {
                errors[errorCounter++]  = 'Membership Verification Start Date cannot be earlier than the membership year start date'
            }

            if (moment(season.membershipStartDate) > moment(season.membershipEndDate)) {
                errors[errorCounter++]  = 'Membership start date cannot be later than the end date'
            }
        }
       else {
            errors[errorCounter]  = "SeasonNotSet"
        } 
    }
    return errors
}
export default reduxForm({
  validate,
  form:formName,
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})(connect(mapStateToProps,mapDispatchToProps)(SeasonDates))




// WEBPACK FOOTER //
// ./src/containers/season/components/SeasonDates.js